<template>
  <v-container fluid grid-list-md>
    <!-- Dialog da dependencia -->
    <!-- <p-dependency ref="taskTemplateDependency" :task_id="editedItem['id']" :task_top_id="editedItem['top_id']" :template="true" @updateDependencylength="(values) => {Object.assign(this.dependency_length, values)}"></p-dependency> -->
    <p-dependency ref="taskTemplateDependency" :task_id="editedItem['id']" :task_top_id="editedItem['top_id']" :template="true" @updateDependencyLength="(values) => Object.assign(this.dependency_length, values)"></p-dependency>

    <!--Dialog para confirmação de exclusão-->
    <p-confirm :text="deleteText" :entity="translate('table.' + entity + '.title')[1]" :dialog="dialogConfirm" @confirm="deleteItem" @cancel="closeDialogDelete"></p-confirm>
    <!--Index-->
    <!-- é usado o v-show para permanecer as subtarefas abertas ao criar ou editar uma tarefa-->
    <v-layout wrap justify-center align-center>
      <v-flex xs12 sm8>
        <span class="headline"><v-icon large class="mr-1" color="primary">{{this.translate('table.tasktemplates.icon')}}</v-icon>Consulta de Modelos de Tarefa (POPs)</span>
      </v-flex>
      <v-flex xs12 sm4>
        <v-text-field append-icon="search" label="Pesquisar" v-model="search"></v-text-field>
      </v-flex>
      <v-flex xs12>
        <p-filter
          ref="filter"
          :allItems="allItems"
          :entity="entity"
          :filterTypes="filterTypes"
          @customFilter="(res)=>{items=res}">
        </p-filter>
      </v-flex>
      <!-- Estilo word-break foi aplicado para impedir overflow do texto no campo da descrição -->
      <v-flex xs12 style="word-break: break-all;">
        <p-tasktemplate-expand :dialog="dialog" :search="search" @createSubItem="createSubItemProcess" @editSubItem="selectTasktemplate" @deleteSubItem="dialogDelete" :headers="headers" :items="items">
        </p-tasktemplate-expand>
      </v-flex>
    </v-layout>
    <v-dialog v-if="dialog" :value="true" persistent scrollable width="60%" :fullscreen="$vuetify.breakpoint.smAndDown">
      <!--è usado o v-if pois quando edita ou criar deve ser recalculado as variaveis cos componentes-->
      <v-card style="padding: 2px; background-color:#fafafa;" >
        <!--Cabeçalho-->
        <v-card-title class="py-2">
          <v-layout v-if="view === 4" align-center justify-space-between wrap>
            <v-flex shrink>
              <v-tooltip bottom>
                <v-btn slot="activator" icon @click="close()">
                  <v-icon>close</v-icon>
                </v-btn>
                <span>Fechar</span>                  
              </v-tooltip>
            </v-flex>
            <v-flex shrink>
              <v-progress-circular v-if="loading_values" :indeterminate="true"></v-progress-circular>
              <span v-else>
                <span>ID: </span>
                <v-hover v-for="son in sons" :key="son.id" >
                  <span slot-scope="{ hover }">
                    <v-chip outline @click="selectTasktemplate(son.id, items, view, false)" :color="son.id === editedItem.id || hover ? 'primary' : ''" :selected="son.id === editedItem.id || hover">
                      <span :style="son.id === editedItem.id ? 'textAlign: center; fontSize: 15pt; textDecoration: underline; color: #02444d; fontWeight: bold;' : 'textAlign: center; fontSize: 13pt; textDecoration: underline; color: #7e8e90; cursor: pointer;'">
                        {{son.identifier}}
                      </span>
                    </v-chip>
                    <span v-if="son.id !== sons[sons.length - 1].id" style="textAlign: center; fontSize: 20pt; color: #7e8e90">.</span>
                  </span>
                </v-hover>
              </span>
            </v-flex>
            <v-flex grow class="text-xs-right">
              <v-layout align-center justify-end row fill-height>
                <v-flex shrink>
                  <v-tooltip top v-if="mountDependency" >
                    <v-btn slot="activator" :disabled="checkIsFree()" @click="$refs.taskTemplateDependency.openDialogDependency()" small fab>
                      <v-badge left :value="dependency_length['total'] > 0">
                        <template v-slot:badge>
                          <span>{{dependency_length['total']}}</span>
                        </template>
                        <v-icon>mediation</v-icon>
                      </v-badge>
                    </v-btn>
                    <span>{{checkIsFree() ? 'Seu plano não possui acesso a adição de pré-requisitos. Faça upgrade para o plano Business!' : 'Tarefas pré-requisitos'}}</span>
                  </v-tooltip>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12>
              <v-hover :disabled="$vuetify.breakpoint.smAndDown">
                <!-- keydown.enter.exact.prevent serve pra quando apertar enter não quebrar uma linha -->
                <v-form slot-scope="{ hover }" ref="tasktemplate_id_text_form">
                  <v-textarea v-if="fieldEditing['tasktemplate_id_text']" id="tasktemplate_id_text" ref="autofocus" maxlength="190" counter="190" rows="1" v-model="editedItem.id_text" :rules="requiredRule(translate('table.' + entity + '.field.id_text'),190)" auto-grow @keydown.enter.exact.prevent
                  @keyup.enter.exact="fieldEdit({id_text: editedItem.id_text}, 'tasktemplate_id_text')"
                  @blur="fieldEdit({id_text: editedItem.id_text}, 'tasktemplate_id_text')" 
                  style="padding-top:0;margin-top:0;"
                  ></v-textarea>
                  <div v-else @click="clickFieldEdit('tasktemplate_id_text')"  :class="hover ? 'show-edit-border' : 'show-edit'">
                    <div class="p-content-id-text break-word"> {{editedItem.id_text}}</div>
                  </div>
                </v-form>
              </v-hover>
            </v-flex>
          </v-layout>
          <v-flex v-else>
            <span class="headline"><v-icon large class="mr-1" color="primary">{{this.translate(`table.${this.entity}.icon`)}}</v-icon>{{formTitle}}</span>
          </v-flex>
        </v-card-title>
        <v-divider style="padding-bottom:5px;"></v-divider>
        <v-card-text class="pa-0" style="overflow-y: auto; overflow-x: hidden;">
          <v-layout row wrap style="min-height: 250px;">
            <!--Management-->
            <v-flex xs12 sm8 v-if="view === 4">
              <v-layout class="px-3 pt-1" row wrap>
                <v-flex xs12>
                  <v-layout row wrap>
                    <!-- identifier -->
                    <!----------------- ver identifier depois -->
                    <v-flex xs12 sm6 v-if="editedItem['level'] > 1">
                      <v-hover :disabled="$vuetify.breakpoint.smAndDown">
                        <v-form slot-scope="{ hover }"  ref="tasktemplate_identifier_form">
                          <v-text-field v-if="fieldEditing['tasktemplate_identifier']" id="tasktemplate_identifier" type="number"  :label="translate('table.' + entity + '.field.identifier')" v-model="editedItem.identifier" @keyup.enter="fieldEdit({identifier: editedItem.identifier}, 'tasktemplate_identifier')" @blur="fieldEdit({identifier: editedItem.identifier}, 'tasktemplate_identifier')" :rules="requiredRule(translate('table.' + entity + '.field.identifier'))" 
                          ></v-text-field>
                          <div v-else :class="hover ? 'show-edit-border' : 'show-edit'">
                          <v-layout>
                            <v-flex xs12>
                              <div @click="clickFieldEdit('tasktemplate_identifier')">
                                <div class="p-label">{{translate('table.' + entity + '.field.identifier')}}</div>
                                <div class="p-content-tasktemplate"> {{editedItem.identifier}}</div>
                              </div>
                            </v-flex>
                          </v-layout>
                          </div>
                        </v-form>
                      </v-hover>
                    </v-flex>
                    <!-- urgency -->
                    <v-flex xs12 sm6>
                      <v-hover :disabled="$vuetify.breakpoint.smAndDown">
                        <v-form slot-scope="{ hover }">
                          <v-select v-if="fieldEditing['tasktemplate_urgency']" id="tasktemplate_urgency" :label="translate('table.' + entity + '.field.urgency')" @click:clear="$nextTick(() => editedItem.urgency=null)" v-model="editedItem.urgency" :items="translate('value.task_urgency')" @change="fieldEdit({urgency: editedItem.urgency}, 'tasktemplate_urgency')" @blur="fieldEditing['tasktemplate_urgency'] = false" :placeholder="editedItem['level'] > 1 ? 'Buscar da Tarefa Mãe' : ''"></v-select>
                          <div v-else :class="hover ? 'show-edit-border' : 'show-edit'">
                            <v-layout>
                              <v-flex xs11>
                                <div @click="clickFieldEdit('tasktemplate_urgency')">
                                  <div class="p-label">{{translate('table.' + entity + '.field.urgency')}}</div>
                                  <div v-if="editedItem.urgency" class="p-content-task" :style="`color:${translate('value.task_urgency').find((val)=>{ return val.value === editedItem.urgency }).color_solid}`">{{translate('value.task_urgency').find((val)=>{ return val.value === editedItem.urgency }).text}}</div>
                                  <div v-else class="p-content-tasktemplate-empty">{{editedItem['level'] > 1 ? 'Buscar da Tarefa Mãe' : 'Escolha uma opção'}}</div>
                                </div>
                              </v-flex>
                              <v-flex xs1>
                                <v-tooltip v-if="editedItem.urgency != null && (hover || $vuetify.breakpoint.smAndDown)" bottom>
                                  <v-btn class="btn-close-edit" slot="activator" icon @click="fieldEdit({urgency: null}, 'tasktemplate_urgency')"><v-icon>close</v-icon></v-btn><span>Limpar</span>                  
                                </v-tooltip>
                              </v-flex>
                            </v-layout>
                          </div>
                        </v-form>
                      </v-hover>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <!-- prevision -->
                <v-flex xs12 v-if="editedItem.level !== 1">
                  <v-hover :disabled="$vuetify.breakpoint.smAndDown">
                    <v-form slot-scope="{ hover }">
                      <v-text-field v-if="fieldEditing['tasktemplate_prevision']" id="tasktemplate_prevision" @keyup.native.esc="close" :label="translate('table.' + entity + '.field.prevision')" type="number" placeholder="Dias que precedem o fim da tarefa mãe" v-model="editedItem.prevision" @keyup.enter="fieldEdit({prevision: editedItem.prevision}, 'tasktemplate_prevision')" @blur="fieldEdit({prevision: editedItem.prevision}, 'tasktemplate_prevision')"></v-text-field>
                      <div v-else :class="hover ? 'show-edit-border' : 'show-edit'">
                        <v-layout>
                          <v-flex xs11>
                            <div @click="clickFieldEdit('tasktemplate_prevision')">
                              <div class="p-label">{{translate('table.' + entity + '.field.prevision')}}</div>
                              <div v-if="editedItem.prevision || editedItem.prevision === 0" class="p-content-task break-word" style="white-space: pre-line;"> {{editedItem.prevision}}</div>
                              <div v-else class="p-content-tasktemplate-empty break-word">Dias que precedem o fim da tarefa mãe</div>
                            </div>
                          </v-flex>
                          <v-flex xs1>
                            <v-tooltip v-if="editedItem.prevision != null && (hover || $vuetify.breakpoint.smAndDown)" bottom>
                              <v-btn class="btn-close-edit" slot="activator" icon @click="fieldEdit({prevision: null}, 'tasktemplate_prevision')"><v-icon>close</v-icon></v-btn><span>Limpar</span>                  
                            </v-tooltip>
                          </v-flex>
                        </v-layout>
                      </div>
                    </v-form>
                  </v-hover>
                </v-flex>
                <!-- team_id -->
                <v-flex xs12 sm6 v-if="checkPlanAccess('teams', 'active')">
                  <v-hover :disabled="$vuetify.breakpoint.smAndDown">
                    <v-form slot-scope="{ hover }">
                      <p-select v-if="fieldEditing['tasktemplate_team_id']" id="tasktemplate_team_id" entity="task_team" :disabled="(editedItem.level !== 1)" :label="translate('table.' + entity + '.field.team_id')" v-model="editedItem.team_id" @change="(id, item) => {changeTeam(id, item, true)}" @blur="fieldEditing['tasktemplate_team_id'] = false" :companyId="editedItem['company_id']" :placeholder="editedItem['level'] > 1 ? 'Buscar da Tarefa Mãe' : ''" :selectedItem="editedItem['team']"></p-select>
                      <div v-else :class="hover ? 'show-edit-border' : 'show-edit'">
                      <v-layout>
                        <v-flex xs11>
                          <div @click="clickFieldEdit('tasktemplate_team_id')">
                            <div class="p-label">{{translate('table.' + entity + '.field.team_id')}}</div>
                            <div v-if="editedItem.team" class="p-content-tasktemplate one-line"> {{editedItem.team.id_text}}</div>
                            <div v-else class="p-content-tasktemplate-empty one-line">{{editedItem['level'] > 1 ? 'Buscar da Tarefa Mãe' : 'Escolha uma opção'}}</div>
                          </div>
                        </v-flex>
                        <v-flex xs1>
                          <v-tooltip class="btn-close-edit" v-if="editedItem.team_id != null && (hover || $vuetify.breakpoint.smAndDown)" bottom>
                            <v-btn slot="activator" icon @click="changeTeam(null, null, true)"><v-icon>close</v-icon></v-btn><span>Limpar</span>                  
                          </v-tooltip>
                        </v-flex>
                      </v-layout>
                      </div>
                    </v-form>
                  </v-hover>
                </v-flex>
                <!-- user_id -->
                <v-flex :class="checkPlanAccess('teams', 'active') ? 'xs12 sm6' : 'xs12'">
                  <v-hover :disabled="$vuetify.breakpoint.smAndDown">
                    <v-form slot-scope="{ hover }">
                      <!-- // Usado o v-show po:notSearchUserIllis="!!editedItem.team_id || (editedItem.company_id !== ($auth.check() ? $auth.user().company_id : 0))" is quando o usuário de outra empresa não possui plano, mostra uma ms que esta no p-select-user -->
                      <p-select-user v-show="fieldEditing['tasktemplate_user_id']"  id="tasktemplate_user_id" :needCompanyPlan="true" :disabled="loading_users" :loading="loading_users" ref="userIllis" v-model="selectedUser" :teamId="editedItem['team_id']" :label="translate('table.' + entity + '.field.user_id')" @input="(val) => { changeResponsible(val, true) }" @blur="fieldEditing['tasktemplate_user_id'] = false" :users="users" :selectedItem="selectedUser" :outCompanyId="editedItem['company_id']" :notSearchUserIllis="!!editedItem.team_id" :placeholder="editedItem['level'] > 1 ? 'Buscar da Tarefa Mãe' : ''"></p-select-user>
                      <div v-show="!fieldEditing['tasktemplate_user_id']" :class="hover ? 'show-edit-border' : 'show-edit'">
                        <v-layout>
                          <v-flex xs11>
                            <div @click="clickFieldEditUser()">
                              <div class="p-label">{{translate('table.' + entity + '.field.user_id')}}</div>
                              <div class="p-content-tasktemplate one-line" v-if="!$auth.check()">{{(editedItem.user_id ? editedItem.user.id_text : 'Sem responsável')}}</div>
                              <div class="p-content-tasktemplate-empty one-line" v-else-if="!editedItem.user_id">{{editedItem['level'] > 1 ? 'Buscar da Tarefa Mãe' : 'Escolha uma opção'}}</div>
                              <div class="p-content-tasktemplate one-line" v-else-if="editedItem.company_id === $auth.user().company_id">{{ editedItem.user.id_text+(editedItem.connection_company ? ('('+editedItem.connection_company.id_text+')') : '')}}</div>
                              <div class="p-content-tasktemplate one-line" v-else-if="editedItem.connection_company_id">{{ editedItem.user.id_text+(editedItem.connection_company_id === $auth.user().company_id ? '' : ('('+editedItem.connection_company.id_text+')')) }}</div>
                              <div class="p-content-tasktemplate one-line" v-else>{{ editedItem.user.id_text+((' ('+editedItem.company.id_text+')'))}}</div>
                            </div>
                          </v-flex>
                          <v-flex xs1>
                            <v-tooltip v-if="editedItem.user_id != null && (hover || $vuetify.breakpoint.smAndDown)" bottom>
                              <v-btn class="btn-close-edit" slot="activator" icon @click="changeResponsible({id: null}, true)"><v-icon>close</v-icon></v-btn><span>Limpar</span>                  
                            </v-tooltip>
                          </v-flex>
                        </v-layout>
                      </div>
                    </v-form>
                  </v-hover>
                </v-flex>
                <!-- client_id -->
                <v-flex xs12 sm6>
                  <v-form>
                    <p-select v-if="fieldEditing['tasktemplate_client_id']" id="tasktemplate_client_id" entity="task_client" :disabled="(editedItem.level !== 1)" :label="translate('table.' + entity + '.field.client_id')" :filter="filterAutocomplete" v-model="editedItem.client_id" @change="(id, item) => fieldEdit({client_id: id, client: item}, 'tasktemplate_client_id')" @blur="fieldEditing['tasktemplate_client_id'] = false" :companyId="editedItem['company_id']" :placeholder="editedItem['level'] > 1 ? 'Buscar da Tarefa Mãe' : ''"></p-select>
                    <v-layout v-else wrap class="ma-0">
                      <v-flex :class="editedItem.client_id ? 'xs10 pa-0' : 'xs12 pa-0'">
                        <v-hover :disabled="$vuetify.breakpoint.smAndDown">
                          <div slot-scope="{ hover }"  :class="hover ? 'show-edit-border' : 'show-edit'">
                            <v-layout>
                              <v-flex xs11>
                                <div @click="clickFieldEdit('tasktemplate_client_id')">
                                  <div class="p-label">{{translate('table.' + entity + '.field.client_id')}}</div>
                                  <div v-if="editedItem.client_id" class="p-content-task one-line">{{editedItem.client.id_text}}</div>
                                  <div v-else class="p-content-tasktemplate-empty one-line">{{editedItem['level'] > 1 ? 'Buscar da Tarefa Mãe' : 'Escolha uma opção'}}</div>
                                </div>
                              </v-flex>
                              <v-flex xs1>
                                <v-tooltip v-if="editedItem.client_id != null && (hover || $vuetify.breakpoint.smAndDown)" bottom>
                                  <v-btn slot="activator" class="btn-close-edit" icon @click="fieldEdit({client_id: null, client: null}, 'tasktemplate_client_id')"><v-icon>close</v-icon></v-btn><span>Limpar</span>                  
                                </v-tooltip>
                              </v-flex>
                            </v-layout>
                          </div>
                        </v-hover>
                      </v-flex>
                      <v-flex :class="editedItem.client_id ? 'xs2 pa-0' : 'pa-0'" v-if="editedItem.client_id">
                        <p-view-client :client_id="editedItem.client_id"></p-view-client>
                      </v-flex>
                    </v-layout>
                  </v-form>
                </v-flex>
                <!-- categiry_id -->
                <v-flex xs12 sm6>
                  <v-hover :disabled="$vuetify.breakpoint.smAndDown">
                    <v-form slot-scope="{ hover }">
                      <p-select-modal-editable v-if="fieldEditing['tasktemplate_category_id']" id="tasktemplate_category_id" entity="task_category" :showActions="editedItem.company_id === $auth.user().company_id || editedItem.identifier === ''" :label="translate('table.' + entity + '.field.category_id')" v-model="editedItem.category_id" :selectedItem="editedItem.category" :values="category_fields" @change="(id, item) => fieldEdit({category_id: id, category: item}, 'tasktemplate_category_id')" :clearable="false" :companyId="editedItem['company_id']" :placeholder="editedItem['level'] > 1 ? 'Buscar da Tarefa Mãe' : ''">
                        <v-container grid-list-md>
                          <v-layout wrap>
                            <v-flex xs2>
                              <v-tooltip bottom>
                                <swatches
                                  slot="activator"
                                  v-model="category_fields.color"
                                  colors="material-basic"
                                  row-length="4"
                                  shapes="circles"
                                  popover-to="right"
                                  :swatch-style="{ margin: '5px 5px' }"
                                  show-fallback
                                ></swatches>
                                <span>Alterar Cor</span>
                              </v-tooltip>
                            </v-flex>
                            <v-flex xs10>
                              <v-text-field id="modalfocus" v-model="category_fields.id_text" :label="translate('table.task_category.field.id_text')"></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </p-select-modal-editable>
                      <div v-else :class="hover ? 'show-edit-border' : 'show-edit'">
                        <v-layout>
                          <v-flex xs11>
                            <div @click="clickFieldEdit('tasktemplate_category_id')">
                              <div class="p-label">{{translate('table.' + entity + '.field.category_id')}}</div>
                              <div v-if="editedItem.category_id" class="p-content-tasktemplate one-line">{{editedItem.category.id_text}}</div>
                              <div v-else class="p-content-tasktemplate-empty one-line">{{editedItem['level'] > 1 ? 'Buscar da Tarefa Mãe' : 'Escolha uma opção'}}</div>
                            </div>
                          </v-flex>
                          <v-flex xs1>
                            <!-- // v-if possui notEmptyArray(selectedBoard['properties']['client']) pois caso tenha algum valor de cliente selecionado no team_id o campo de cliente vira obrigatorio não podendo limpar -->
                            <v-tooltip v-if="editedItem.category_id != null && (hover || $vuetify.breakpoint.smAndDown)" bottom>
                              <v-btn slot="activator" icon class="btn-close-edit" @click="fieldEdit({category_id: null, category: null}, 'tasktemplate_category_id')"><v-icon>close</v-icon></v-btn><span>Limpar</span>                  
                            </v-tooltip>
                          </v-flex>
                        </v-layout>
                      </div>
                    </v-form>
                  </v-hover>
                </v-flex>
                <!-- note -->
                <v-flex xs12>
                  <v-hover :disabled="$vuetify.breakpoint.smAndDown">
                    <v-form slot-scope="{ hover }">
                      <v-textarea id="tasktemplate_note"  v-if="fieldEditing['tasktemplate_note']" maxlength="10000" counter="10000" rows="2" :label="translate('table.' + entity + '.field.note')" name="note" v-model="editedItem.note" auto-grow @blur="fieldEdit({note: editedItem.note}, 'tasktemplate_note')" >
                      </v-textarea>
                      <div v-else :class="hover ? 'show-edit-border' : 'show-edit'">
                        <v-layout>
                          <v-flex xs11>
                            <div @click="clickFieldEdit('tasktemplate_note')">
                              <div class="p-label">{{translate('table.' + entity + '.field.note')}}</div>
                              <div v-if="editedItem.note" class="p-content-task break-word" style="white-space: pre-line;"> {{editedItem.note}}</div>
                              <div v-else class="p-content-tasktemplate-empty break-word">Digite uma observação</div>
                            </div>
                          </v-flex>
                          <v-flex xs1>
                            <v-tooltip v-if="editedItem.note != null && (hover || $vuetify.breakpoint.smAndDown)" bottom>
                              <v-btn class="btn-close-edit" slot="activator" icon @click="fieldEdit({note: null}, 'tasktemplate_note')"><v-icon>close</v-icon></v-btn><span>Limpar</span>                  
                            </v-tooltip>
                          </v-flex>
                        </v-layout>
                      </div>
                    </v-form>
                  </v-hover>
                </v-flex>
              </v-layout>
              <!-- buttons -->
              <v-layout style="position: absolute; bottom: 15px; right: 15px; ; z-index: 10" align-center>
                <v-tooltip top>
                  <v-btn slot="activator" fab small @click="close()">
                    <v-icon>{{this.translate('system.button.close.icon')}}</v-icon>
                  </v-btn>
                  <span>{{this.translate('system.button.close.title')}}</span>
                </v-tooltip>
              </v-layout>
            </v-flex>
            <!-- Create edit -->
            <v-flex xs12 sm8 v-else>
              <v-form v-model="valid" ref="form">
                <!--Create Edit-->
                <v-container fluid grid-list-xs style="padding: 2px">
                  <v-layout row wrap>
                    <!-- id_text -->
                    <v-flex xs12>
                      <v-textarea @keyup.native.ctrl.enter="save(4)" ref="autofocus" maxlength="190" :label="translate('table.' + entity + '.field.id_text')" counter="190" rows="1" v-model="editedItem.id_text" :rules="requiredRule(translate('table.' + entity + '.field.id_text'),190)" auto-grow
                      ></v-textarea>
                    </v-flex>
                    <v-flex xs12>
                      <v-layout>
                        <!-- urgency -->
                        <v-flex xs12 sm6>
                          <v-select :label="translate('table.' + entity + '.field.urgency')" @click:clear="$nextTick(() => editedItem.urgency=null)" @keyup.native.ctrl.enter="save(4)" v-model="editedItem.urgency" :items="translate('value.task_urgency')" :placeholder="editedItem['level'] > 1 ? 'Buscar da Tarefa Mãe' : ''" clearable></v-select>
                        </v-flex>
                        <!-- prevision -->
                        <v-flex xs12 sm6 v-if="editedItem.level !== 1">
                          <v-text-field @keyup.native.esc="close()" :label="translate('table.' + entity + '.field.prevision')" type="number" placeholder="Dias que precedem o fim da tarefa mãe"
                                        v-model="editedItem.prevision"></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <!-- team_id -->
                    <v-flex xs12 sm6>
                      <p-select id="tasktemplate_team_id" entity="task_team" :disabled="(editedItem.level !== 1)" :label="translate('table.' + entity + '.field.team_id')" v-model="editedItem.team_id" @change="changeTeam" :placeholder="editedItem['level'] > 1 ? 'Buscar da Tarefa Mãe' : ''" :selectedItem="editedItem['team']" clearable :hint="editedItem['level'] > 1 ? 'Não é possivel alterar a equipe das tarefas filhas' : ''" persistent_hint></p-select>
                    </v-flex>
                    <!-- user_id -->
                    <v-flex xs12 sm6>
                      <!-- :itemsNotShow="itemsNotShow" -->
                      <p-select-user @keyup.native.ctrl.enter="save(4)" :needCompanyPlan="true" :disabled="loading_users" :loading="loading_users" ref="userIllis" v-model="selectedUser" :users="users" :label="translate('table.' + entity + '.field.user_id')" @input="changeResponsible" :notSearchUserIllis="!!editedItem.team_id" :selectedItem="editedItem['user']" clearable :placeholder="editedItem['level'] > 1 ? 'Buscar da Tarefa Mãe' : ''"></p-select-user>
                    </v-flex>
                    <!-- client_id -->
                    <v-flex xs12 sm6>
                      <p-select id="tasktemplate_client_id" entity="task_client" :disabled="(editedItem.level !== 1)" :label="translate('table.' + entity + '.field.client_id')" v-model="editedItem.client_id" :selectedItem="editedItem.client" :placeholder="editedItem['level'] > 1 ? 'Buscar da Tarefa Mãe' : ''" clearable @change="(id, item) => {editedItem['client'] = item}" :hint="editedItem['level'] > 1 ? 'Não é possivel alterar o cliente das tarefas filhas' : ''" persistent_hint></p-select>
                    </v-flex>
                    <!-- category_id -->
                    <v-flex xs12 sm6>
                      <p-select-modal-editable
                        id='tasktemplate_category_id'
                        :showActions="true" @change="(id, item) => {editedItem['category'] = item}"
                        :label="translate('table.' + entity + '.field.category_id')"
                        v-model="editedItem.category_id" entity="task_category"
                        :values="category_fields" :selectedItem="editedItem.category" :placeholder="editedItem['level'] > 1 ? 'Buscar da Tarefa Mãe' : ''">
                        <v-container grid-list-md>
                          <v-layout wrap>
                            <v-flex xs2>
                              <v-tooltip bottom>
                                <swatches
                                  slot="activator"
                                  v-model="category_fields.color"
                                  colors="material-basic"
                                  row-length="4"
                                  shapes="circles"
                                  popover-to="right"
                                  :swatch-style="{ margin: '5px 5px' }"
                                  show-fallback
                                ></swatches>
                                <span>Alterar Cor</span>
                              </v-tooltip>
                            </v-flex>
                            <v-flex xs10>
                              <v-text-field id="modalfocus" v-model="category_fields.id_text" :label="translate('table.task_category.field.id_text')"></v-text-field>
                            </v-flex>
                            <!-- O campo ativo foi ocultado dos status. Posteriormente será retrabalhado e voltará a ser exibido
                            <v-flex xs12>
                              <v-switch :label="translate('table.task_category.field.active')"
                                        v-model="category_fields.active"></v-switch>
                            </v-flex> -->
                          </v-layout>
                        </v-container>
                      </p-select-modal-editable>
                    </v-flex>
                    <!-- note -->
                    <v-flex xs12>
                      <v-textarea @keyup.native.ctrl.enter="save(4)" maxlength="10000" counter="10000" auto-grow
                          rows="2" :label="translate('table.' + entity + '.field.note')" name="note" required  v-model="editedItem.note">
                      </v-textarea>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>
            </v-flex>
            <!-- Campos personalizados -->
            <v-flex xs12 sm4 style="border: 2 0 0 0 #cecece;">
              <p-custom-field ref="PCustomField" :origin_field_name="'tasktemplate_id'" :tasktemplate_id="editedItem['id']" @closeFieldEditing="closeFieldEditing" :originView="view"></p-custom-field>
            </v-flex>
          </v-layout>
          <!-- buttons -->
          <!-- //  loading_users inserido no loading para quando estiver carregando os usuários da equipe, não deixar salvar até terminar para n salvar usuário como responsável em equipes que eles n participam -->
          <!-- // coloca os botões fora do create acima, se não ele fica por baixo dos campos personalizados quando tem muitos campos -->
          <v-layout v-if="view === 2" style="position: absolute; bottom: 15px; right: 15px;" align-center>
            <v-speed-dial v-model="fab" open-on-hover>
              <v-tooltip left slot="activator">
                <v-btn v-model="fab" slot="activator" fab color="primary" :loading="loading || loading_users" dark @click="saveEdit()">
                  <v-icon>{{this.translate('system.button.save.icon')}}</v-icon>
                  <v-icon>{{this.translate('system.button.build.icon')}}</v-icon>
                </v-btn>
                <span>{{this.translate('system.button.save_manage.title')}}</span>
              </v-tooltip>

              <v-tooltip left>
                <v-btn slot="activator" fab small color="accent" :loading="loading || loading_users" @click="save()">
                  <v-icon>{{this.translate('system.button.save_close.icon')}}</v-icon>
                </v-btn>
                <span>{{this.translate('system.button.save_close.title')}}</span>
              </v-tooltip>

              <v-tooltip left>
                <v-btn slot="activator" fab small color="secondary" :loading="loading || loading_users" @click="saveNew()"
                      :disabled="!checkPlanAccess(entity, 'qtd', allItems.length + 1)">
                  <v-icon>{{this.translate('system.button.save_new.icon')}}</v-icon>
                </v-btn>
                <span>{{this.translate('system.button.save_new.title')}}</span>
              </v-tooltip>
            </v-speed-dial>
            <v-tooltip top>
              <v-btn slot="activator" fab small @click="close()">
                <v-icon>{{this.translate('system.button.close.icon')}}</v-icon>
              </v-btn>
              <span>{{this.translate('system.button.close.title')}}</span>
            </v-tooltip>
          </v-layout>
          <!-- Detalhes -->
          <v-progress-linear v-if="loading_values" :indeterminate="true"></v-progress-linear>
          <v-layout v-else-if="view == 4"  wrap justify-center align-center>
            <v-flex xs12>
              <v-tabs dark color="cyan" v-model="tab" grow class="elevation-1">
                <v-tabs-slider color="yellow"></v-tabs-slider>
                <v-tab key="0" v-if="editedItem.level === 1">
                  {{this.translate('table.forms.title')[1]}}
                  <v-badge v-if="form_length > 0" class="badge" color="#039BE5" right>
                    <span slot="badge">{{form_length}}</span>
                  </v-badge>
                </v-tab>
                <v-tab key="1">
                  {{this.translate('table.task_checklist.title')[1]}}
                  <v-badge v-if="checklist_length > 0" class="badge" color="#039BE5" right>
                    <span slot="badge">{{checklist_length}}</span>
                  </v-badge>
                </v-tab>
                <v-tab key="2">
                  {{this.translate('table.task_reminder.title')[1]}}
                  <v-badge v-if="reminder_length > 0" class="badge" color="#039BE5" right>
                    <span slot="badge">{{reminder_length}}</span>
                  </v-badge>
                </v-tab>
                <v-tab key="3" v-if="editedItem.level === 1">
                  {{this.translate('table.task_user.title')[1]}}
                  <v-badge v-if="user_length > 0" class="badge" color="#039BE5" right>
                    <span slot="badge">{{user_length}}</span>
                  </v-badge>
                </v-tab>
                <v-tab key="4" v-if="editedItem.level === 1">
                  {{this.translate('table.tasktemplate_document.title')[1]}}
                  <v-badge v-if="document_length > 0" class="badge" color="#039BE5" right>
                    <span slot="badge">{{document_length}}</span>
                  </v-badge>
                </v-tab>
                <v-tab key="5">
                  {{this.translate('table.tasktemplate_automation.title')[1]}}
                  <v-badge v-if="automation_length > 0" class="badge" color="#039BE5" right>
                    <span slot="badge">{{automation_length}}</span>
                  </v-badge>
                </v-tab>
                <v-tabs-items v-model="tab" touchless>
                  <v-tab-item key="0" v-if="editedItem.level === 1">
                    <v-card>
                      <v-card-text>
                        <p-form @itemsLength="val => form_length = val" :tasktemplate_id="editedItem['id']"></p-form>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                  <v-tab-item key="1">
                    <v-card>
                      <v-card-text>
                        <checklist @itemsLength="val => checklist_length = val" :tasktemplate="editedItem"></checklist>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                  <v-tab-item key="2">
                    <v-card>
                      <v-card-text>
                        <reminder @itemsLength="val => reminder_length = val" :tasktemplate="editedItem"></reminder>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                  <v-tab-item key="3" v-if="editedItem.level === 1">
                    <v-card>
                      <v-card-text>
                        <user @itemsLength="val => user_length = val" :tasktemplate="editedItem"></user>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                  <v-tab-item key="4" v-if="editedItem.level === 1">
                    <v-card>
                      <v-card-text>
                        <document @itemsLength="val => document_length = val" :tasktemplate="editedItem"></document>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                  <v-tab-item key="5">
                    <v-card>
                      <v-card-text>
                        <automation @itemsLength="val => automation_length = val" :tasktemplate_id="editedItem['id']"></automation>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>
                </v-tabs-items>
              </v-tabs>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-layout v-if="view === 1" class="fab-container" align-center>
      <v-tooltip top>
        <v-btn slot="activator" color="primary" fab @click="createTasktemplate" :disabled="!checkPermission(entity, 'create') || !checkPlanAccess(entity, 'qtd', allItems.length)">
          <v-icon>{{this.translate('system.button.add.icon')}}</v-icon>
        </v-btn>
        <span>{{createTooltipText}}</span>
      </v-tooltip>
    </v-layout>
  </v-container>
</template>

<style scoped>
  .btn-close-edit {
    position: relative;
    right: 25px;
  }
  .btn-close-edit-mobile {
    position: relative; 
    right: 35px;
  }
  .show-edit-border {
    cursor: pointer;
    min-height: 50px;
    border-radius: 5px;
    border: 1px solid;
    padding-left: 5px;
    padding-right: 8px;
  }
  .show-edit {
    min-height: 50px;
    border: 1px solid;
    border-color: rgba(255, 255, 255, 0);
    padding-left: 5px;
  }
  .p-label {
    font-size: 9pt;
    color: #1d1d1d;
    font-weight: 600;
  }
  .p-content-id-text {
    font-size: 13pt;
    font-weight: 600;
  }
  .p-content-tasktemplate {
    font-size: 12pt;
  }
  .p-content-tasktemplate-empty {
    font-size: 10pt;
    color: #96989A;
  }
  tr td:last-child {
    min-width: 130px;
  }

  .fab-container {
    position: fixed;
    bottom: 16px;
    right: 16px;
    z-index: 4;
  }

  .badge {
    padding-right: 15px;
    padding-bottom: 10px;
  }  

</style>

<script>
  /* eslint-disable eqeqeq */
  import crud from '../mixin/crud'
  import access from '../mixin/access'
  import rules from './../mixin/rules'
  import tooltip from './../mixin/tooltip'
  import Checklist from './details/TemplateChecklist'
  import Document from './details/TemplateDocument'
  import Automation from './details/TemplateAutomation'
  import Reminder from './details/TemplateReminder'
  import User from './details/TemplateUser'
  import PDateTime from './shared/PDateTime'
  import PSelectUser from './shared/PSelectUser'
  import PSelect from './shared/PSelect'
  import PTasktemplateExpand from './shared/PTasktemplateExpand'
  import PDependency from './shared/PDependency'
  import PSelectModalEditable from './shared/PSelectModalEditable'
  import PFilter from './shared/PFilter'
  import PSelectEditable from '../components/shared/PSelectEditable'
  import Swatches from 'vue-swatches'
  import PConfirm from '../components/shared/PConfirm'
  import socket from '../mixin/socketTasktemplate'
  import PViewClient from './shared/PViewClient'
  import PCustomField from './shared/PCustomField'
  import PForm from './shared/PForm'

  export default {
    mixins: [crud, access, rules, tooltip, socket],
    components: {PForm, Swatches, PDependency, PSelectModalEditable, PSelectEditable, PTasktemplateExpand, Checklist, Document, Automation, Reminder, User, PDateTime, PFilter, PConfirm, PSelectUser, PSelect, PViewClient, PCustomField},
    data: () => ({
      loading_values: false,
      // fieldEditing identifica e gerencia qual o campo que está em edição
      fieldEditing: {tasktemplate_id_text: false, tasktemplate_team_id: false, tasktemplate_user_id: false, tasktemplate_client_id: false, tasktemplate_urgency: false, tasktemplate_category_id: false, tasktemplate_dates: false, tasktemplate_recurrence: false, tasktemplate_note: false, tasktemplate_identifier: false, tasktemplate_prevision: false},
      defaultFieldEditing: {tasktemplate_id_text: false, tasktemplate_team_id: false, tasktemplate_user_id: false, tasktemplate_client_id: false, tasktemplate_urgency: false, tasktemplate_category_id: false, tasktemplate_dates: false, tasktemplate_recurrence: false, tasktemplate_note: false, tasktemplate_identifier: false, tasktemplate_prevision: false},
      setDurationInterval: '',
      selectedUser: null,
      itemsSubTask: [],
      itemFather: {},
      editSubTask: [],
      entity: 'tasktemplates',
      teams: [],
      clients: [],
      deleteText: '',
      mountDependency: true,
      users: [],
      allUsers: [],
      category_fields: {id_text: '', active: true, color: ''},
      reminder_length: 0,
      checklist_length: 0,
      document_length: 0,
      automation_length: 0,
      user_length: 0,
      form_length: 0,
      dependency_length: {total: 0, color: ''},
      beginDefaultItem: {},
      categories: [],
      type: 'task_category',
      date: null,
      loading_users: false,
      menu_begin: false,
      tab: null,
      fab: null,
      menu_end: false,
      sons: []
    }),
    created () {
      this.$store.commit('loader/change_dialog', true)
      this.$socket.emit('joinRoom', {room: this.socketRoom})

      // Busca os items para os filtros
      this.$http.get(`api/complement_task`).then(res => {
        // O teams_user traz todas as equipe pois o teams_userestá sendo usado nas tarefas tbm, logo deve ser feito o filtro para trazer apenas as equipes do usuário
        this.teams = res.body['teams_user'].filter((val) => {
          return (val.users_team.some((user) => { return user.user_id === this.$auth.user().id }))
        })
        this.clients = res.body['clients']
        this.allUsers = JSON.parse(JSON.stringify(res.body['all_users_company']))
        this.categories = res.body['task_categories'] || []
        // this.usersTeam = res.body['get_users_teams'] || []
      })
      this.editedItem = {'id_text': '', 'note': '', 'team_id': null, 'user_id': null, 'user_index': null, 'connection_id': null, 'connection_company_id': null, 'category_id': null, 'client_id': null, 'urgency': null, 'sons': [], 'company_id': this.$auth.user().company_id, 'checklists': [], 'users': [], 'reminders': [], 'documents': [], 'automations': []}
      this.defaultItem = {'id_text': '', 'note': '', 'team_id': null, 'user_id': null, 'user_index': null, 'connection_id': null, 'connection_company_id': null, 'category_id': null, 'client_id': null, 'urgency': null, 'sons': [], 'company_id': this.$auth.user().company_id, 'checklists': [], 'users': [], 'reminders': [], 'documents': [], 'automations': []}
      // Usado para sempre manter os valores iniciais, pois o defaultItem modifica os valores em alguns processos
      this.beginDefaultItem = {'id_text': '', 'note': '', 'team_id': null, 'user_id': null, 'user_index': null, 'connection_id': null, 'connection_company_id': null, 'category_id': null, 'client_id': null, 'urgency': null, 'sons': [], 'company_id': this.$auth.user().company_id, 'checklists': [], 'users': [], 'reminders': [], 'documents': [], 'automations': []}
      this.initialize()
    },
    destroyed () {
      this.$socket.emit('leaveRoom', {room: `${this.entity}${this.$auth.user().company_id}`})
      this.$socket.emit('leaveRoom', {room: `${this.entity}${this.$auth.user().company_id}_${this.editedItem.id}`})
      this.$socket.emit('leaveRoom', {room: `${this.entity}${this.$auth.user().company_id}_${this.editedItem.id}_edit`})
    },
    methods: {
      changeOrderSequence (values) {
        if (!values) {
          return []
        } else if (values['tree_tasktemplate_sequence'] === null) {
          return [values.id]
        } else {
          let order = this.changeOrderSequence(values['tree_tasktemplate_sequence'])
          order.push(values.id)
          return order
        }
      },
      afterInsert (newValues) {
        this.$socket.emit('generalEvent', {
          data: newValues,
          responseEvent: 'addSocketItem',
          room: this.socketRoom
        })
      },
      close (viewAfterSave = 1) {
        // zera os usuários pois eles estavam vindo preenchidos com valores antigos
        this.users = []
        this.view = viewAfterSave
        this.dialog = this.view != 1
        // Caso ira retornar pra tela de consulta zera os valores
        if (viewAfterSave === 1) {
          // Se view = 4, ou seja, tela de gerenciamento. Retiramos o usuário da sala em que ele estava anteriormente (edição).
          if (this.view == 4) this.$socket.emit('leaveRoom', { room: `${this.socketRoom}_${this.editedItem.id}` })
          this.editedItem = Object.assign(JSON.parse(JSON.stringify(this.beginDefaultItem)), {})
          this.beforeEditedItem = Object.assign(JSON.parse(JSON.stringify(this.beginDefaultItem)), {})
          this.selectedUser = {id: null, id_text: ''}
          this.defaultItem = {'team_id': null, 'user_id': null, 'user_index': null, 'connection_id': null, 'connection_company_id': null, 'category_id': null, 'client_id': null, 'urgency': null}
        }
        // Fecha todos os campos caso tenha algum aberto
        this.fieldEditing = JSON.parse(JSON.stringify(this.defaultFieldEditing))
      },
      beforeEditSocketItem (item) {
        // ve se o modelo de tarefa editada ja existia na lista
        let topTask = this.allItems.find((val) => {
          return val.id === item.top_id
        })
        // caso nao exista ve se ela deveria aparecer na lista, pois ja que foi editada agora os privilegios podem ter sido alterados, ex: voce ser incluido na equipe da tarefa
        // caso exista ve se agora os privilegios foram retirados e se ela deve ser retirada, ex: voce ser excluido da equipe da tarefa
        if (!topTask) {
          if (item['team_id'] && (!item['team']['users_team'].some(a => { return ((a.user_id === this.$auth.user().id) && (a.connection_company_id === null)) }))) {
            return false
          } else {
            this.allItems.push(item)
            this.items.push(item)
          }
        } else {
          if (item['team_id'] && (!item['team']['users_team'].some(a => { return ((a.user_id === this.$auth.user().id) && (a.connection_company_id === null)) }))) {
            this.allItems.splice(this.allItems.findIndex((val) => {
              return val.id === item.id
            }), 1)
            this.items.splice(this.items.findIndex((val) => {
              return val.id === item.id
            }), 1)
            return false
          }
        }
      },
      beforeAddSocketItem (item) {
        if (item['team_id']) {
          if (!item['team']['users_team'].some(a => { return ((a.user_id === this.$auth.user().id) && (a.connection_company_id === null)) })) {
            return false
          }
        }
      },
      afterDelete (oldValues) {
        this.$socket.emit('generalEvent', {
          data: oldValues,
          responseEvent: 'deleteSocketItem',
          room: this.socketRoom
        })
        let item = {text: `O modelo de tarefa "${oldValues.id_text}" foi excluída. Será necessário recarregar a página.`}
        this.$socket.emit('generalEvent', {
          data: item,
          responseEvent: 'reloadPage',
          room: `${this.socketRoom}_${oldValues.id}`
        })
      },
      afterEditSocketManagementDetails (item) {
        this.changeTeam(item.values.team_id, item.values['team'])
        if (item.values.user_id) {
          let userIndex = {
            company_id: item.values.connection_company_id ? item.values.connection_company_id : item.values.company_id,
            company_id_text: item.values.connection_company ? item.values.connection_company.id_text : null,
            connection_id: item.values.connection_id,
            email: item.values.user.email,
            id: `${item.values.user_id}-${item.values.connection_company_id ? item.values.connection_company_id : item.values.company_id}`,
            id_text: `${item.values.user.id_text} (${item.values.user.email})`,
            logo_path: item.values.connection_company ? item.values.connection_company.logo_path : null,
            photo_path: item.values.user.photo_path,
            user_id: item.values.user_id,
            connection_status: 2
          }
          if (userIndex) {
            this.selectedUser = userIndex
            this.changeResponsible(userIndex)
          }
        }
      },
      afterUpdate (newValues) {
        this.$socket.emit('generalEvent', {
          data: {values: newValues, entity: 'modelo de tarefa'},
          responseEvent: 'editSocketManagementDetails',
          room: `${this.socketRoom}_${newValues.id}`
        })
        this.$socket.emit('generalEvent', {
          data: newValues,
          responseEvent: 'editSocketItem',
          room: `${this.socketRoom}`
        })
      },
      initialize () {
        this.$http.get(`api/get_tasktemplate_team`).then(res => {
          this.items = res.body
          this.allItems = JSON.parse(JSON.stringify(res.body))
          this.checkQtdAccess(this.entity, this.allItems.length, false)
          this.afterInitialize(res.body)
        }, err => {
          console.log(err)
          this.$store.commit('snackbar/change_values', {text: 'Não foi possível carregar os registros de ' + this.translate('table.' + this.entity + '.title')[0] + ', reporte o erro.', color: 'error', dialog: true})
        })
      },
      changeTeam (val = this.editedItem.team_id, item = null, saveValuesBd = false) {
        // nos casos de cliente ou equipe verifica se é subtaref caso seja, não deixa editar, pois é permitido inserir ou editar registros se for um usuário da propria empresa
        if (val === null && this.editedItem['level'] > 1) {
          this.$store.commit('snackbar/change_values', {text: 'Não é possivel editar cliente ou equipe de tarefas filhas ou tarefas de parceiros!', color: 'warning', dialog: true})
          return false
        }
        // se for salvar no banco, primeiro verifica se existe acesso, exemplo, quando o usuário é apenas parcipante e clica no x para zerar a equipe
        if (saveValuesBd) {
          if (!this.checkPermission(this.entity, 'edit')) {
            this.$store.commit('snackbar/change_values', {text: 'Você não possui permissões para editar!', color: 'warning', dialog: true})
            return false
          }
        }
        this.editedItem.team = item
        if (val) {
          this.loading_users = true
          this.$http.get(`api/get_teams_users_illis/${val}`).then(res => {
            this.users = res.body
            // this.users.unshift({id: null, id_text: this.editedItem['level'] > 1 ? 'Buscar da Tarefa Mãe' : 'Vazio'})
            let selectedUser = this.selectedUser ? this.users.find((user) => { return user.id === this.selectedUser['id'] }) : null
            this.loading_users = false
            // se o usuário selecionado não estiver na equipe selecionada o campo é limpado
            if (!selectedUser) {
              this.changeResponsible(null)
            }
            if (saveValuesBd) {
              // caso tenha usuário entao apenas salva a equipe ,caso não tenha usuário já zera o campo de usuário tbm
              let values = selectedUser ? {team_id: val} : {team_id: val, user: null, connection_id: null, connection_company_id: null}
              this.fieldEdit(values, 'task_team_id')
            }
          }, err => {
            console.log(err)
            this.loading_users = false
            this.$store.commit('snackbar/change_values', {text: 'Não foi possível carregar os registros do campo responsável, reporte o erro.', color: 'error', dialog: true})
          })
        } else {
          // caso não tenha selecionado equipe, volta o users para vazio para ser pesquisado no proprio componente
          this.users = []
          // caso não tenha id da equipe então so verifica se é pra salvar o valor no banco, necessário quando limpa a equipe
          if (saveValuesBd) {
            this.fieldEdit({team_id: null}, 'task_team_id')
          }
        }
      },
      createTasktemplate () {
        Object.assign(this.defaultItem, {
          level: 1
        })
        this.itemsSubTask = this.items
        this.create()
      },
      dialogDelete (item, items) {
        this.deleteText = ''
        this.$http.get(`api/verifyRecurrences/${item['id']}`).then(res => {
          if (res.body === '1' || res.body === 1) {
            this.deleteText = 'Podem existir recorrências que utilizam esse modelo de tarefa, ao excluí-la aparecerá somente o cabeçalho nas próximas, perdendo os detalhes. Tem certeza que deseja excluir o item de '
          } else {
            this.deleteText = 'Tem certeza que deseja excluir o item de '
          }
          this.dialogConfirm = true
          this.editedItem = item
          this.itemsSubTask = items
        })
      },
      changeSubtaskstemplateCount (item, type = 'add', change = false, task = null, i = 1) {
        // Quando é a primeira vez verifica se existe filhas pois se tiver muda a sequencia com o changeOrderSequence para ficar mais facil a manipulação
        if (i === 1) {
          task = this.allItems.find((val) => { return val.id === item.top_id })
          if (item.tree_tasktemplate_sequence) {
            item.sequence = this.changeOrderSequence(item.tree_tasktemplate_sequence)
          }
        }
        if (item.tasktemplate_id === task.id) {
          // se o tipo for de adição irá incluir um registro se não irá tirar
          task.subtasks_clean_count += ((type === 'add') ? 1 : -1)
          if (change) {
            if (type === 'add') {
              task.all_subtasks.push(item)
            } else if (type === 'del') {
              const taskIndex = task.all_subtasks.findIndex((val) => { return val.id === (item.sequence[i] ? item.sequence[i] : item.id) })
              task.all_subtasks.splice(taskIndex, 1)
            }
          }
          // como está sendo atualizado o AllItems, o object.assign garante que será atualizado nas tarefas mostradas para o usuário tbm
          let itemTask = this.items.find((val) => { return val.id === item.top_id })
          if (itemTask) {
            let allItemTask = this.allItems.find((val) => { return val.id === item.top_id })
            Object.assign(itemTask, JSON.parse(JSON.stringify(allItemTask)))
          }
          return true
        } else {
          let sonItem = task.all_subtasks.find((val) => {
            return val.id === (item.sequence[i] ? item.sequence[i] : item.id)
          })
          if (sonItem) {
            i += 1
            this.changeSubtaskstemplateCount(item, type, change, sonItem, i)
          }
        }
      },
      reloadFilter () {
        // Refaz os filtros depois de uma edição da tarefa.
        if ((Object.keys(this.$refs.filter.filter).length > 0)) {
          this.$refs.filter.customFilter(null, false)
        }
      },
      deleteItem () {
        const index = this.itemsSubTask.indexOf(this.editedItem)
        let level = this.editedItem.level

        this.$store.commit('loader/change_dialog', true)
        this.$http.delete(`api/${this.entity}/${this.editedItem.id}`).then(
          (res) => {
            this.itemsSubTask.splice(index, 1)
            if (level === 1) {
              this.allItems = this.allItems.filter((val) => { return val.id !== res.body.id })
              this.afterDelete(res.body)
            } else {
              this.$socket.emit('generalEvent', {
                data: res.body,
                responseEvent: 'deleteSubTask',
                room: `${this.socketRoom}`
              })
              let item = {text: `O modelo de tarefa "${res.body.id_text}" foi excluída. Será necessário recarregar a página.`}
              this.$socket.emit('generalEvent', {
                data: item,
                responseEvent: 'reloadPage',
                room: `${this.socketRoom}_${res.body.id}`
              })
            }
            this.$store.commit('loader/change_dialog', false)
            this.$store.commit('snackbar/change_values', {text: 'Registro de ' + this.translate('table.' + this.entity + '.title')[0] + ' excluído com sucesso!', color: 'success', dialog: true})
          },
          err => {
            console.log(err)
            this.$store.commit('loader/change_dialog', false)
            this.$store.commit('snackbar/change_values', {text: 'Não foi possível deletar o registro de ' + this.translate('table.' + this.entity + '.title')[0] + ', reporte o erro.', color: 'error', dialog: true})
          })
        this.closeDialogDelete()
      },
      selectTasktemplate (tasktemplateId, items, view, changeSons = true) {
        this.itemsSubTask = items
        this.$store.commit('loader/change_dialog', true)
        this.loading_values = true
        // volta o tab para 0, pois quando estava em um tab alto e ia pra modelo filha, os gerenciamentos não msotravam
        this.tab = 0
        this.$http.get(`api/${this.entity}/${tasktemplateId}`).then((res) => {
          this.editItem(res.body, view, changeSons)
          this.$store.commit('loader/change_dialog', false)
          this.loading_values = false
          // Carrega os registros de dependencia
          this.$refs.taskTemplateDependency.reloadDependencies(true, tasktemplateId)
        }, (err) => {
          console.log('err', err)
          this.$store.commit('snackbar/change_values', {text: 'Não foi possível acessar o registro de ' + this.translate('table.' + this.entity + '.title')[0] + ', reporte o erro.', color: 'error', dialog: true})
          this.$store.commit('loader/change_dialog', false)
        })
      },
      // changeSons serve para mudar a sequencia dos filhos quando o usuário entra em outra tarefa pela consulta, caso ele entre pela sequencia de tarefas do cabeçalho ai não muda
      editItem (item, view = 4, changeSons = false) {
        this.$socket.emit('joinRoom', {room: `${this.socketRoom}_${item.id}`, view: view})
        // this.levelAdjustment(item.level)
        // const view = {index: 1, create: 2, edit: 3, management: 4}
        this.view = view
        this.dialog = this.view !== 1
        // Quando é uma filha insere o cliente e a equipe, pois no banco sempre estara como null (Buscar da tarefa mae)
        let allItem = this.allItems.find((val) => { return val.id === item.top_id })
        item['client_id'] = allItem.client_id
        item['client'] = allItem.client
        item['team_id'] = allItem.team_id
        item['team'] = allItem.team
        Object.assign(this.editedItemDB, JSON.parse(JSON.stringify(item)))
        Object.assign(this.editedItem, JSON.parse(JSON.stringify(item)))
        // Sempre deve recarregar os campos, tanto no gerenciamento para pegar eles e também na inclusão de tarefa modelo para vir vazio
        // setTimeout para dar tempo do origimView mudar pra 4
        setTimeout(() => {
          if (this.$refs.PCustomField) this.$refs.PCustomField.getCustomFields('tasktemplate_id', 0, this.editedItem['id'])
        }, 100)
        if (changeSons) {
          this.sons = this.editedItem.sons
        }
      },
      createSubItemProcess (item, items) {
        this.itemFather = item
        this.itemsSubTask = items
        this.createSubItem(item)
      },
      createSubItem: function (item) {
        // Quando é uma filha insere o cliente e a equipe, pois no banco sempre estara como null (Buscar da tarefa mae)
        let allItem = this.allItems.find((val) => { return val.id === item.top_id })
        Object.assign(this.defaultItem, { top_id: item.top_id || item.id, tasktemplate_id: item.id, level: item.level + 1, client_id: allItem.client_id, client: allItem.client, team_id: allItem.team_id, team: allItem.team })
        // caso tenha equipe, pede para carregar os usuários
        if (allItem['team_id'] > 0) this.changeTeam(allItem['team_id'], allItem['team'])
        this.create()
      },
      afterCreate () {
        this.selectedUser = {id: null, id_text: null}
        // Volta o default Para o que ele era antes pois no createSubItem ele é modificado
        this.defaultItem = this.beginDefaultItem
      },
      changeResponsible (val, saveValuesBd = false) {
        // se for salvar no banco, primeiro verifica se existe acesso, exemplo, quando o usuário é apenas parcipante e clica no x para zerar o responsável
        if (saveValuesBd) {
          if (!this.checkPermission(this.entity, 'edit')) {
            this.$store.commit('snackbar/change_values', {text: 'Você não possui permissões para editar!', color: 'warning', dialog: true})
            return false
          }
        }
        if (val && val.id !== null && val.id !== {}) {
          this.selectedUser = val
          this.editedItem.user_id = val.user_id
          this.editedItem.connection_id = val.connection_id
          this.editedItem.connection_company_id = (parseInt(val.company_id) !== this.$auth.user().company_id ? val.company_id : null)
        } else {
          this.selectedUser = {id: null, id_text: null}
          this.editedItem.user_id = null
          this.editedItem.connection_id = null
          this.editedItem.connection_company_id = null
        }
        if (saveValuesBd) {
          this.editedItem.user = this.selectedUser ? this.selectedUser : {}
          this.fieldEdit({user_id: this.editedItem.user_id, connection_id: this.editedItem.connection_id, connection_company_id: this.editedItem.connection_company_id}, 'tasktemplate_user_id')
        }
      },
      clickFieldEditUser (item = this.editedItem) {
        if (!this.checkPermission(this.entity, 'edit')) {
          this.$store.commit('snackbar/change_values', {text: 'Você não possui permissões para editar!', color: 'warning', dialog: true})
          return false
        }
        // Monta o usuário pra ficar no formato correto
        if (item.user_id) {
          this.selectedUser = {
            company_id: item.connection_company_id ? item.connection_company_id : item.company_id,
            company_id_text: item.connection_company ? item.connection_company.id_text : item.company.id_text,
            connection_id: item.connection_id,
            email: item.user.email,
            id: `${item.user_id}-${item.connection_company_id ? item.connection_company_id : item.company_id}`,
            id_text: `${item.user.id_text} (${item.user.email})`,
            logo_path: item.connection_company ? item.connection_company.logo_path : item.company.logo_path,
            photo_path: item.user.photo_path,
            user_id: item.user_id,
            connection_status: 2
          }
          this.changeResponsible(this.selectedUser)
        } else {
          this.changeResponsible(null)
        }
        this.clickFieldEdit('tasktemplate_user_id')
      },
      clickFieldEdit (field) {
        if (!this.checkPermission(this.entity, 'edit')) {
          this.$store.commit('snackbar/change_values', {text: 'Você não possui permissões para editar!', color: 'warning', dialog: true})
          return false
        }
        // nos casos de cliente ou equipe verifica se é subtarefa ou se a empresa do registro é diferente da empresa do usuário, caso seja, não deixa editar, pois é permitido inserir ou editar registros se for um usuário da propria empresa
        if ((field === 'tasktemplate_client_id' || field === 'tasktemplate_team_id') && (this.editedItem['level'] > 1)) {
          this.$store.commit('snackbar/change_values', {text: 'Não é possivel editar cliente ou equipe de tarefas filhas ou tarefas de parceiros!', color: 'warning', dialog: true})
          return false
        }
        // closeFieldEditing para fechar todos os outros campos que eestariam aberto, pois por enquanto não da pra colocar no blur já que o usuário pode fazer outras coisas como editar ou excluir camposigual a categoria ou o status
        this.closeFieldEditing(field)
        // Uma das utilidades do beforEditItem é verifica se o valor foi alterado para salvar
        this.beforeEditedItem = JSON.parse(JSON.stringify(this.editedItem))
        // Habilita a edição do filtro
        this.fieldEditing[field] = true
        setTimeout(() => {
          document.getElementById(field).click()
        }, 100)
      },
      fieldEdit (values, field) {
        // nos casos de cliente ou equipe verifica se é subtarefa ou se a empresa do registro é diferente da empresa do usuário, caso seja, não deixa editar, pois é permitido inserir ou editar registros se for um usuário da propria empresa
        if ((field === 'tasktemplate_client_id' || field === 'tasktemplate_team_id') && (this.editedItem['level'] > 1)) {
          this.$store.commit('snackbar/change_values', {text: 'Não é possivel editar cliente ou equipe de tarefas filhas ou tarefas de parceiros!', color: 'warning', dialog: true})
          return false
        }
        // não permite o usuário editar caso não tenha acesso
        if (!this.checkPermission(this.entity, 'edit')) {
          this.$store.commit('snackbar/change_values', {text: 'Você não possui permissões para editar!', color: 'warning', dialog: true})
          return false
        }
        setTimeout(() => {
          if ((this.$refs[field + '_form'] && !this.$refs[field + '_form'].validate())) {
            this.$store.commit('snackbar/change_values', {
              text: 'Por favor, corrija as validações antes de salvar!',
              color: 'warning',
              dialog: true
            })
            this.editedItem = JSON.parse(JSON.stringify(this.beforeEditedItem))
            return false
          }
          this.fieldEditing[field] = false
          // verifica se foi alterado algum valor, caso tenha sido alterado, salva.
          // tbm verifica quando o valor é null pois nesse caso foi clicaco no x e no x o beforeEditedItem ainda não recebeu valores sendo null tbm
          let saveValues = false
          for (var prop in values) {
            // é colocado !== na primeira validação pois a precisão quando é 0 estava considerando vazio tbm
            if (values[prop] !== this.beforeEditedItem[prop] || values[prop] === null) {
              saveValues = true
            }
          }
          // if (saveValues) this.savePut(values, editedItem)
          if (saveValues) {
            // faz o editedItem receber os valores no caso de vir null
            Object.assign(this.editedItem, JSON.parse(JSON.stringify(values)))
            this.save(4)
          }
        }, 100)
      },
      save (viewAfterSave) {
        if (this.$refs.form && !this.$refs.form.validate()) {
          this.$store.commit('snackbar/change_values', {text: 'Por favor, corrija as validações antes de salvar!', color: 'warning', dialog: true})
          return false
        }
        this.loading = true
        this.$store.commit('loader/change_dialog', true)
        if (this.view === 2) {
          // Quando é uma sub modelo de tarefa zera o cliente e a equipe para salvar no banco null e buscar da tarefa mae quando for inserir a tarefa
          if (this.editedItem.level > 1) {
            this.editedItem.client_id = null
            this.editedItem.team_id = null
          }
          // Pega os valores do customField para mandar pra controller para ser tudo adicionado
          let customFields = this.$store.state.customField.values
          if (customFields.length > 0) this.editedItem['customFields'] = customFields
          this.$http.post('api/' + this.entity, this.editedItem).then(
            (res) => {
              this.editedItemDB = JSON.parse(JSON.stringify(res.body))
              this.itemsSubTask.push(JSON.parse(JSON.stringify(res.body)))
              if (res.body.level === 1) {
                this.allItems.push(JSON.parse(JSON.stringify(res.body)))
                this.afterInsert(JSON.parse(JSON.stringify(res.body)))
                this.checkQtdAccess(this.entity, this.allItems.length)
              } else {
                // esse push e utilizado para tambem colocar no all items pois esta so colocado no items
                let allitem = this.allItems.find(a => {
                  return a.id === res.body.top_id
                })
                let item = (JSON.parse(JSON.stringify(this.items.find(a => {
                  return a.id === res.body.top_id
                }))))
                Object.assign(allitem, item)
                this.$socket.emit('generalEvent', {
                  data: res.body,
                  responseEvent: 'addSubTasktemplate',
                  room: `tasktemplates` + this.$auth.user().company_id
                })
              }
              // zera os usuários pois eles estavam vindo preenchidos com valores antigos
              this.users = []
              // A verificação da próxima tela a ser aberta(viewAfterSave) é feita dentro do post, pois o Items precisa ter incluido pelo o push os valores
              // para que a próxima tela a ser aberta funcione corretamente
              if (viewAfterSave === 2) {
                // ao salvar e novo zera os campos personalizados
                this.$store.commit('customField/change_values', [])
                if (res.body.level === 1) {
                  this.createTasktemplate()
                } else {
                  this.createSubItemProcess(this.itemFather, this.itemsSubTask)
                }
              } else if (viewAfterSave === 4) {
                this.editItem(this.editedItemDB, viewAfterSave, true)
              } else {
                this.close(viewAfterSave)
              }
              this.loading = false
              this.sons = res.body['sons']
              this.$store.commit('loader/change_dialog', false)
              this.$store.commit('snackbar/change_values', {text: 'Registro de ' + this.translate('table.' + this.entity + '.title')[0] + ' incluído com sucesso!', color: 'success', dialog: true})
            },
            err => {
              console.log(err)
              this.loading = false
              this.$store.commit('loader/change_dialog', false)
              this.$store.commit('snackbar/change_values', {text: 'Não foi possível incluir o registro de ' + this.translate('table.' + this.entity + '.title')[0] + ', reporte o erro.', color: 'error', dialog: true})
            })
        } else if (this.view === 4) {
          this.$http.put('api/' + this.entity + '/' + this.editedItem.id,
            this.editedItem).then(
            (res) => {
              // caso o identifier anterior seja diferente do atual, significa que foi alterado o identifier portanto deve recrregar a numeração
              if (this.editedItemDB['identifier'] != res.body['identifier']) this.sons = res.body['sons']
              this.editedItemDB = JSON.parse(JSON.stringify(res.body))
              Object.assign(this.editedItem, JSON.parse(JSON.stringify(res.body)))
              Object.assign(this.itemsSubTask.find(
                (val) => { return val.id === this.editedItem.id }) || {}, res.body)
              if (res.body.level === 1) {
                Object.assign(this.allItems.find(
                  (val) => { return val.id === this.editedItem.id }) || {}, res.body)
                this.afterUpdate(res.body)
              } else {
                this.$socket.emit('generalEvent', {
                  data: res.body,
                  responseEvent: 'editSubTask',
                  room: `tasktemplates` + this.$auth.user().company_id
                })
                this.$socket.emit('generalEvent', {
                  data: {values: res.body, entity: 'modelo de tarefa'},
                  responseEvent: 'editSocketManagementDetails',
                  room: `${this.socketRoom}_${res.body.id}`
                })
              }
              this.close(viewAfterSave)
              this.$store.commit('loader/change_dialog', false)
              this.loading = false
              this.$store.commit('snackbar/change_values', {text: 'Registro de ' + this.translate('table.' + this.entity + '.title')[0] + ' editado com sucesso!', color: 'success', dialog: true})
            },
            err => {
              alert('Erro! Falha ao enviar a requisição.')
              console.log(err)
              this.$store.commit('loader/change_dialog', false)
              this.loading = false
              this.$store.commit('snackbar/change_values', {text: 'Não foi possível editar o registro de ' + this.translate('table.' + this.entity + '.title')[0] + ', reporte o erro.', color: 'error', dialog: true})
            }
          )
        }
      },
      closeFieldEditing (field = '') {
        Object.assign(this.fieldEditing, this.defaultFieldEditing)
        if (field !== '') this.fieldEditing[field] = true
        this.$refs.PCustomField.closeFieldEditing()
      }
    },
    computed: {
      filterTypes: function () {
        return [
          {field: 'identifier', type: 'integer'},
          {field: 'id_text', type: 'string'},
          {field: 'user_id', type: 'array', items: this.allUsers, text: 'id_text', value: 'id'},
          {field: 'team_id', type: 'array', items: this.teams, text: 'id_text', value: 'id'},
          {field: 'client_id', type: 'array', items: this.clients, text: 'id_text', value: 'id'},
          {field: 'category_id', type: 'array', items: this.categories, text: 'id_text', value: 'id'},
          {field: 'prevision', type: 'integer'},
          {field: 'urgency', type: 'array', items: this.translate('value.task_urgency')},
          {field: 'note', type: 'string'}
        ]
      },
      headers: function () {
        return [
          {text: this.translate('table.' + this.entity + '.field.all_subtasks'), value: 'all_subtasks', sortable: false},
          {text: this.translate('table.' + this.entity + '.field.identifier'), value: 'identifier'},
          {text: this.translate('table.' + this.entity + '.field.id_text'), value: 'id_text'},
          {text: this.translate('table.' + this.entity + '.field.prevision'), value: 'prevision'},
          {text: this.translate('system.table.action'), value: 'action', sortable: false, align: 'center'}
        ]
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Tasktemplate.vue